module.exports = __webpack_public_path__ + "img/logo_cockpit_color.0c1b046a.svg";